(function () {
  'use strict';
  function init() {
    document.querySelectorAll('[data-ss-variant-picker]').forEach(function (picker) {
      if (picker.dataset.initialized) return;
      picker.dataset.initialized = 'true';
      var data = picker.querySelector('[data-ss-variants]');
      if (!data) return;
      var variants = JSON.parse(data.textContent);
      var selects = Array.from(picker.querySelectorAll('[data-ss-option]'));
      selects.forEach(function (select) {
        select.addEventListener('change', function () {
          var values = selects.map(function (el) { return el.value; });
          var changed = Number(select.dataset.optionIndex);
          var variant = variants.find(function (v) {
            return v.options.every(function (value, index) { return value === values[index]; });
          });
          // An incomplete option matrix must still resolve to a real configuration.
          if (!variant) variant = variants.find(function (v) { return v.options[changed] === select.value; });
          if (!variant) return;
          var url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          // Server rendering keeps price, availability, both cart forms and metadata in sync.
          window.location.assign(url.toString());
        });
      });
      var root = picker.closest('[data-ss-product]');
      var selected = picker.querySelector('[data-ss-selected-configuration]');
      var configuration = selected ? selected.textContent.trim() : '';
      var price = root.querySelector('.ss-price');
      var details = configuration + (price ? ' — ' + price.textContent.trim() : '');
      root.querySelectorAll('a[href^="mailto:"]').forEach(function (link) {
        var url = new URL(link.href);
        url.searchParams.set('body', 'Configuration: ' + details + '\nProduct: ' + window.location.href);
        link.href = url.toString();
      });
      document.querySelectorAll('[data-ss-quote]').forEach(function (button) {
        button.addEventListener('click', function () {
          var modal = document.querySelector('[data-ss-modal]');
          if (!modal) return;
          var content = modal.querySelector('iframe');
          if (!content) return;
          var note = modal.querySelector('[data-ss-quote-configuration]');
          if (!note) {
            note = document.createElement('p');
            note.className = 'ss-quote-configuration';
            note.dataset.ssQuoteConfiguration = '';
            content.parentNode.insertBefore(note, content);
          }
          note.textContent = 'Selected configuration: ' + details;
        });
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
